import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import useReveal from './hooks/useReveal';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Benefits from './components/Benefits';
import WhyChooseUs from './components/WhyChooseUs';
import Industries from './components/Industries';
import CaseStudies from './components/CaseStudies';
// import Testimonials from './components/Testimonials';
import ROICalculator from './components/ROICalculator';
// import Partners from './components/Partners';
import CloudPlatforms from './components/CloudPlatforms';
import About from './components/About';
// import Contact from './components/Contact';
import Footer from './components/Footer';
// import Assistant from './components/Assistant';

import './App.css';

function App() {
  useReveal();

  return (
    <ThemeProvider>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Benefits />
        <WhyChooseUs />
        <Industries />
        <CaseStudies />
        {/* <Testimonials /> */}
        <ROICalculator />
        {/* <Partners /> */}
        <CloudPlatforms />
        <About />
        {/* <Contact /> */}
      </main>
      <Footer />
      {/* <Assistant /> */}
    </ThemeProvider>
  );
}

export default App;